webpackJsonp([36],{

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _Heading = __webpack_require__(565);

var _Heading2 = _interopRequireDefault(_Heading);

var _Heading3 = __webpack_require__(562);

var _Heading4 = _interopRequireDefault(_Heading3);

var _Paragraph = __webpack_require__(543);

var _Paragraph2 = _interopRequireDefault(_Paragraph);

var _RequestContactv = __webpack_require__(892);

var _RequestContactv2 = _interopRequireDefault(_RequestContactv);

var _NewMenu = __webpack_require__(551);

var _NewMenu2 = _interopRequireDefault(_NewMenu);

var _NewFooterV = __webpack_require__(544);

var _NewFooterV2 = _interopRequireDefault(_NewFooterV);

__webpack_require__(896);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = (0, _reactStatic.withRouteData)(function (_ref) {
    var headData = _ref.headData,
        company = _ref.company;
    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
            _reactStatic.Head,
            null,
            _react2.default.createElement(
                'title',
                null,
                headData.pageTitle
            ),
            _react2.default.createElement('meta', { property: 'og:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'twitter:title', content: headData.pageTitle }),
            _react2.default.createElement('meta', { name: 'description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { name: 'twitter:description', content: headData.pageDescription }),
            _react2.default.createElement('meta', { property: 'og:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { name: 'twitter:image', content: headData.ogImage }),
            _react2.default.createElement('meta', { property: 'og:url', content: headData.ogUrl }),
            _react2.default.createElement('link', { rel: 'canonical', href: headData.ogUrl })
        ),
        _react2.default.createElement(MarketplacePartner, { company: company })
    );
});


var PARTNERS_THAT_SET_UP_IN_MERCOS = [];
var PARTNERS_WITH_HIDDEN_SITE_LINK = ['cigam', 'gipi-sistemas', 'grupo-telluria', 'sci-sistemas-contabeis', 'spark-software', 'storm-system', 'bis-consultoria'];

var MarketplacePartner = function (_Component) {
    _inherits(MarketplacePartner, _Component);

    function MarketplacePartner(props) {
        _classCallCheck(this, MarketplacePartner);

        var _this = _possibleConstructorReturn(this, (MarketplacePartner.__proto__ || Object.getPrototypeOf(MarketplacePartner)).call(this, props));

        _this.state = {
            isSegmentsOpen: false,
            isServicesOpen: false
        };
        return _this;
    }

    _createClass(MarketplacePartner, [{
        key: 'toggleList',
        value: function toggleList(label) {
            this.setState(_defineProperty({}, 'is' + label + 'Open', !this.state['is' + label + 'Open']));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var companyData = this.props.company.data,
                id = companyData.id,
                title = companyData.title,
                ranking = companyData.ranking,
                logo = companyData.logo,
                color = companyData.color,
                email = companyData.email,
                shortDescription = companyData.short_description,
                description = companyData.description,
                indication = companyData.indication,
                address = companyData.address,
                category = companyData.category,
                regions = companyData.regions,
                segments = companyData.segments,
                services = companyData.services,
                portifolioOwner = companyData.portifolio_owner,
                slug = companyData.slug;
            var rawUrl = companyData.url && String(companyData.url).trim();
            var url = rawUrl && !PARTNERS_WITH_HIDDEN_SITE_LINK.includes(slug) ? '' + (rawUrl.indexOf('//') > -1 ? rawUrl : 'http://' + rawUrl) + (rawUrl.indexOf('?') > -1 ? '&' : '?') + 'utm_source=mercos&utm_medium=marketplace&utm_campaign=mercos-marketplace-indication' : null;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-partner-details-container' },
                    _react2.default.createElement(_NewMenu2.default, { mutableMenu: true, pixelsToShowMenuWhite: 50 }),
                    _react2.default.createElement('div', { className: 'top-purple-bg' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'partner-details-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'container' },
                            _react2.default.createElement(
                                'div',
                                { className: 'navigation-breadcrumbs' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'breadcrumbs desktop-only' },
                                    _react2.default.createElement(
                                        'a',
                                        { href: '/integracao-erp', className: 'button-txt' },
                                        'ERPs Integrados'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'navigation-breadcrumbs-separator' },
                                        '/'
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        title
                                    )
                                ),
                                _react2.default.createElement(
                                    'a',
                                    { className: 'back-button', href: '/integracao-erp' },
                                    '\u2039 voltar'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                _extends({ className: 'partner-head-container' }, color && { style: { backgroundColor: color } }),
                                _react2.default.createElement('div', { className: 'partner-logo-container', style: { backgroundImage: 'url(\'' + logo + '\')' } }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'cta-container' },
                                    _react2.default.createElement(
                                        _RequestContactv2.default,
                                        {
                                            className: 'btn-partner-contact',
                                            color: color,
                                            portifolioOwner: portifolioOwner,
                                            partnerEmail: email,
                                            partnerId: id,
                                            partnerName: title },
                                        'FALAR COM PARCEIRO'
                                    ),
                                    PARTNERS_THAT_SET_UP_IN_MERCOS.includes(slug) && _react2.default.createElement(
                                        'a',
                                        {
                                            className: 'new-button button-secondary-black',
                                            target: '_blank',
                                            title: 'Configure no mercos',
                                            href: 'https://app.mercos.com/nova_integracao/?erp=' + slug },
                                        'CONFIGURAR NO MERCOS'
                                    ),
                                    url && _react2.default.createElement(
                                        'a',
                                        {
                                            className: 'button-txt marketplace-partner-url',
                                            target: '_blank',
                                            title: 'Configure no mercos',
                                            href: url },
                                        'site do parceiro \u203A'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'partner-content-container' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'content-container top-container' },
                                    _react2.default.createElement(
                                        _Heading2.default,
                                        { className: 'partner-name' },
                                        title
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'left-container' },
                                    description && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container title-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Descri\xE7\xE3o do neg\xF3cio:'
                                        ),
                                        _react2.default.createElement(
                                            _Paragraph2.default,
                                            null,
                                            description
                                        )
                                    ),
                                    segments && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container partner-segments-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Segmento que atende:'
                                        ),
                                        segments.map(function (segment, index) {
                                            var isHidden = !this.state.isSegmentsOpen && index > 4;

                                            return _react2.default.createElement(
                                                _Paragraph2.default,
                                                { className: (0, _classnames2.default)('list-item', isHidden && 'hide'), key: 'partner-segment-' + (index + 1) },
                                                '\u2022 ' + segment
                                            );
                                        }, this),
                                        segments.length > 5 && _react2.default.createElement(
                                            _Paragraph2.default,
                                            { className: (0, _classnames2.default)('toggle-button', this.state.isSegmentsOpen && 'open'), onClick: function onClick() {
                                                    return _this2.toggleList('Segments');
                                                } },
                                            this.state.isSegmentsOpen ? 'Esconder' : 'Ver mais'
                                        )
                                    ),
                                    services && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container partner-services-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Servi\xE7os:'
                                        ),
                                        services.map(function (service, index) {
                                            var isHidden = !this.state.isServicesOpen && index > 4;

                                            return _react2.default.createElement(
                                                _Paragraph2.default,
                                                { className: (0, _classnames2.default)('list-item', isHidden && 'hide'), key: 'partner-service-' + (index + 1) },
                                                '\u2022 ' + service
                                            );
                                        }, this),
                                        services.length > 5 && _react2.default.createElement(
                                            _Paragraph2.default,
                                            { className: (0, _classnames2.default)('toggle-button', this.state.isServicesOpen && 'open'), onClick: function onClick() {
                                                    return _this2.toggleList('Services');
                                                } },
                                            this.state.isServicesOpen ? 'Esconder' : 'Ver mais'
                                        )
                                    ),
                                    indication && _react2.default.createElement(
                                        'div',
                                        { className: (0, _classnames2.default)('content-container partner-indication-container', color && 'custom-color') },
                                        _react2.default.createElement(
                                            _Paragraph2.default,
                                            null,
                                            indication
                                        ),
                                        _react2.default.createElement('div', { className: 'indication-background', style: { 'backgroundColor': color } })
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'right-container' },
                                    category && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container category-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Categoria:'
                                        ),
                                        _react2.default.createElement(
                                            _Paragraph2.default,
                                            null,
                                            category
                                        )
                                    ),
                                    regions && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container regions-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Regi\xE3o que atende:'
                                        ),
                                        _react2.default.createElement(
                                            _Paragraph2.default,
                                            null,
                                            regions.join(', ')
                                        )
                                    ),
                                    address && _react2.default.createElement(
                                        'div',
                                        { className: 'content-container address-container' },
                                        _react2.default.createElement(
                                            _Heading4.default,
                                            null,
                                            'Sede da empresa:'
                                        ),
                                        _react2.default.createElement(
                                            _Paragraph2.default,
                                            null,
                                            address
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(_NewFooterV2.default, null)
                )
            );
        }
    }]);

    return MarketplacePartner;
}(_react.Component);

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webpSrc = _ref.webpSrc,
        mobileSrc = _ref.mobileSrc,
        alt = _ref.alt,
        className = _ref.className,
        desktop = _ref.desktop,
        mobile = _ref.mobile,
        noWebp = _ref.noWebp,
        fetchPriority = _ref.fetchPriority,
        width = _ref.width,
        height = _ref.height,
        style = _ref.style,
        loading = _ref.loading,
        onLoad = _ref.onLoad,
        srcSet = _ref.srcSet,
        sizes = _ref.sizes,
        decoding = _ref.decoding,
        imgProps = _objectWithoutProperties(_ref, ['src', 'webpSrc', 'mobileSrc', 'alt', 'className', 'desktop', 'mobile', 'noWebp', 'fetchPriority', 'width', 'height', 'style', 'loading', 'onLoad', 'srcSet', 'sizes', 'decoding']);

    // Detect external URLs - if src starts with http:// or https://, it's external
    var isExternal = src && (src.startsWith('http://') || src.startsWith('https://'));
    // Skip WebP for external URLs or when noWebp prop is explicitly set
    var shouldSkipWebp = noWebp || isExternal;

    var extension = src.split('.').pop();
    var isSvg = extension.toLowerCase() === 'svg';
    var webpSource = webpSrc || src.replace('.' + extension, '.webp');
    var desktopClass = desktop ? 'desktop-only' : '';
    var mobileClass = mobile ? 'mobile-only' : '';
    var loadingValue = loading || (fetchPriority ? "eager" : "lazy");

    // Common img props to pass through
    var commonImgProps = _extends({
        className: className + ' ' + desktopClass + ' ' + mobileClass,
        src: '' + src,
        alt: '' + alt,
        loading: loadingValue,
        width: width,
        height: height,
        style: style,
        onLoad: onLoad,
        srcSet: srcSet,
        sizes: sizes,
        decoding: decoding,
        fetchpriority: fetchPriority }, imgProps);

    // For SVG files, just return a simple img tag without picture/source elements
    if (isSvg) {
        return _react2.default.createElement('img', commonImgProps);
    }

    return _react2.default.createElement(
        'picture',
        null,
        mobileSrc && _react2.default.createElement(
            _react.Fragment,
            null,
            !shouldSkipWebp && _react2.default.createElement('source', {
                srcSet: webpSource + ', ' + mobileSrc.replace('.' + extension, '.webp') + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/webp'
            }),
            _react2.default.createElement('source', {
                srcSet: src + ', ' + mobileSrc + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/' + extension
            })
        ),
        !shouldSkipWebp && _react2.default.createElement('source', { srcSet: '' + webpSource, type: 'image/webp' }),
        _react2.default.createElement('img', commonImgProps)
    );
};

exports.default = Picture;

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createUrlsParamBasedOnCookies = createUrlsParamBasedOnCookies;
exports.redirectWithCookies = redirectWithCookies;

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUrlsParamBasedOnCookies() {
	var campain = _jsCookie2.default.get('mutm_campaign');
	var medium = _jsCookie2.default.get('mutm_medium');
	var source = _jsCookie2.default.get('mutm_source');
	var term = _jsCookie2.default.get('mutm_term');
	var content = _jsCookie2.default.get('mutm_content');
	var fbclid = _jsCookie2.default.get('mfbclid');
	var gclid = _jsCookie2.default.get('mgclid');
	var gad_campaignid = _jsCookie2.default.get('madscampaignid');
	if (campain || medium || source) {
		var params = campain ? '&utm_campaign=' + campain : '';
		params += medium ? '&utm_medium=' + medium : '';
		params += source ? '&utm_source=' + source : '';
		params += term ? '&utm_term=' + term : '';
		params += content ? '&utm_content=' + content : '';
		params += fbclid ? '&fbclid=' + fbclid : '';
		params += gclid ? '&gclid=' + gclid : '';
		params += gad_campaignid ? '&gad_campaignid=' + gad_campaignid : '';
		return '?' + params.slice(1);
	}
	return '';
}

function redirectWithCookies(url) {
	var paramsCookie = createUrlsParamBasedOnCookies();
	var currentURL = window.location.href;

	_jsCookie2.default.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = '' + url + paramsCookie;
}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
    var ariaLabel = _ref.ariaLabel,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        model = _ref.model,
        onClick = _ref.onClick,
        purple = _ref.purple,
        radius = _ref.radius,
        size = _ref.size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        shake = _ref.shake;
    return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)('button', model, size, radius, className, purple && 'purple', shake && 'shake'),
            type: type,
            onClick: onClick,
            'aria-label': ariaLabel,
            disabled: disabled },
        children
    );
};

Button.propTypes = {
    className: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    children: _propTypes2.default.any,
    model: _propTypes2.default.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['button', 'submit']),
    radius: _propTypes2.default.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
};

exports.default = Button;

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseButton = __webpack_require__(538);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

__webpack_require__(540);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloseButton = function getCloseButton(callbackCloseModal, hasImage) {
  return _react2.default.createElement(
    'div',
    { className: 'site-close-modal-button' },
    hasImage,
    _react2.default.createElement(_CloseButton2.default, { outlineOnly: !hasImage, onClickButton: callbackCloseModal })
  );
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayColor = _ref.overlayColor,
      imageURL = _ref.imageURL,
      callbackCloseModal = _ref.callbackCloseModal,
      children = _ref.children,
      video = _ref.video,
      overlayStyles = _ref.overlayStyles,
      hideCloseButton = _ref.hideCloseButton;

  var hasImage = Boolean(imageURL);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('site-modal-container', className) },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)({ 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage }, video ? 'video' : '', overlayStyles ? overlayStyles : '')
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('site-modal-content text-left', video ? 'video' : '') },
        children
      ),
      hasImage && _react2.default.createElement('div', {
        className: 'site-modal-image',
        style: { background: 'url(\'' + imageURL + '\') no-repeat center' }
      }),
      !hideCloseButton && getCloseButton(callbackCloseModal, hasImage)
    ),
    _react2.default.createElement('div', {
      className: (0, _classnames2.default)('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : ''),
      onClick: callbackCloseModal
    })
  );
};

exports.default = Modal;

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(539);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClickButton = _ref.onClickButton,
        _ref$outlineOnly = _ref.outlineOnly,
        outlineOnly = _ref$outlineOnly === undefined ? false : _ref$outlineOnly;
    return _react2.default.createElement('button', { className: (0, _classnames2.default)({
            'site-close-button-outline': outlineOnly,
            'site-close-button': !outlineOnly
        }), onClick: onClickButton });
};

exports.default = CloseButton;

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        inputPlaceholder = _ref.inputPlaceholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement(
        'div',
        { className: 'floating-label-wrapper' },
        _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
            'aria-label': ariaLabel,
            autoFocus: autoFocus,
            id: id,
            maxLength: maxLength,
            onChange: onChange,
            placeholder: inputPlaceholder,
            type: type,
            value: value,
            name: name || id,
            required: true
        }),
        _react2.default.createElement(
            'span',
            { className: 'floating-label' },
            placeholder
        )
    );
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    inputPlaceholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paragraph = function Paragraph(_ref) {
    var center = _ref.center,
        children = _ref.children,
        className = _ref.className,
        gray = _ref.gray,
        italic = _ref.italic,
        left = _ref.left,
        _onClick = _ref.onClick,
        small = _ref.small,
        white = _ref.white;
    return _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)('paragraph', className, center && 'text-center', gray && 'heading-gray', italic && 'italic', left && 'text-left', small && 'small', white && 'heading-white'),
            onClick: function onClick(e) {
                return _onClick ? _onClick(e) : null;
            } },
        children
    );
};

exports.default = Paragraph;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NewFooter;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(545);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewFooter() {
    var accessLinks = [{ name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true }, { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }];

    var footerRows = [[{
        title: 'Soluções',
        links: [{ name: 'Força de vendas', url: '/forca-vendas/' }, { name: 'E-commerce B2B', url: '/e-commerce-b2b/' }, { name: 'CRM', url: '/crm-de-vendas' }, { name: 'Mercos Pay', url: '/mercos-pay' }, { name: 'Videochamada', url: '/videochamada/' }]
    }, {
        title: 'Recursos',
        links: [{ name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' }, { name: 'Indicadores de vendas', url: '/recursos/indicadores-performance/' }, { name: 'Políticas comerciais', url: '/recursos/politica-comercial-vendas/' }, { name: 'Mercos IA', url: '/recursos/mercos-ia/' }]
    }, {
        title: 'Conteúdo',
        links: [{ name: 'Blog', url: 'https://blog.mercos.com/', external: true }, { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI', external: true }, { name: _react2.default.createElement(
                _react2.default.Fragment,
                null,
                'E-commerce B2B: O',
                _react2.default.createElement('br', null),
                'que \xE9?'
            ), url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank', external: true }]
    }, {
        title: 'Transparência',
        links: [{ name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' }, { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' }, { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank', external: true }, { name: 'Relatório da igualdade salarial', url: '/relatorio-igualdade-salarial/' }]
    }, {
        title: 'Suporte',
        links: [{ name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb', external: true }, {
            custom: true,
            content: _react2.default.createElement(
                'div',
                { className: 'support-info' },
                _react2.default.createElement(
                    'div',
                    { className: 'support-phone' },
                    '(47) 3481.8050'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'support-hours' },
                    'Atendimento de Segunda',
                    _react2.default.createElement('br', null),
                    'a Quinta das 9h \xE0s 17h.',
                    _react2.default.createElement('br', null),
                    'Sexta das 9h30 \xE0s 17h.'
                )
            )
        }]
    }], [{
        title: 'Segmentos',
        links: [{ name: 'Indústrias', url: '/industrias/' }, { name: 'Distribuidoras', url: '/distribuidoras/' }, { name: 'Representantes', url: '/representantes-comerciais/' }]
    }, {
        title: 'Planos e preços',
        links: [{ name: 'Indústrias e distribuidoras', url: '/planos-e-precos/industrias-e-distribuidoras/' }, { name: 'Representantes', url: '/planos-e-precos/representantes/' }]
    }, {
        title: 'Institucional',
        links: [{ name: 'Carreira', url: 'https://mercos.gupy.io/' }, { name: 'Sobre Nós', url: '/sobre/' }]
    }, {
        title: 'Integrações',
        links: [{ name: 'ERPs integrados', url: '/integracao-erp/' }, { name: 'Seja Parceiro', url: '/parceiros' }, { name: 'Documentação da API', url: 'https://docs.mercos.com/', external: true }]
    }, {
        title: 'Baixe o aplicativo',
        content: _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'app-buttons' },
                _react2.default.createElement(
                    'a',
                    { href: 'https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/app-store.png', alt: 'Baixar na App Store' })
                ),
                _react2.default.createElement(
                    'a',
                    { href: 'https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/google-play.png', alt: 'Dispon\xEDvel no Google Play' })
                )
            ),
            _react2.default.createElement(
                'p',
                { className: 'app-downloads' },
                _react2.default.createElement(
                    'strong',
                    null,
                    '+100 mil'
                ),
                ' downloads'
            )
        )
    }]];

    var renderLink = function renderLink(link) {
        var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'footer-link';

        if (link.custom) return link.content;
        var target = link.target || (link.external ? '_blank' : null);

        return _react2.default.createElement(
            'a',
            {
                className: className,
                href: link.redirect ? null : link.url,
                onClick: link.redirect ? function () {
                    return (0, _Utm.redirectWithCookies)(link.url);
                } : null,
                target: target,
                rel: target === '_blank' ? 'noopener noreferrer' : null
            },
            link.name,
            link.external && _react2.default.createElement(
                'span',
                { className: 'material-icons site-footer__external-icon', 'aria-hidden': 'true' },
                'north_east'
            )
        );
    };

    var socialLinks = [{ name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' }, { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' }, { name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' }, { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' }, { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }];

    return _react2.default.createElement(
        'footer',
        { className: 'mercos-footer site-footer', 'aria-label': 'Rodap\xE9' },
        _react2.default.createElement(
            'div',
            { className: 'footer-content site-footer__inner' },
            _react2.default.createElement(
                'div',
                { className: 'site-footer__access' },
                _react2.default.createElement(
                    'p',
                    { className: 'site-footer__access-txt' },
                    'J\xE1 \xE9 cliente ou quer come\xE7ar?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'site-footer__access-actions' },
                    accessLinks.map(function (link, index) {
                        return _react2.default.createElement(
                            _react2.default.Fragment,
                            { key: link.url },
                            renderLink(link, 'site-footer__access-btn site-footer__access-btn--' + (index === 0 ? 'login' : 'signup'))
                        );
                    })
                )
            ),
            _react2.default.createElement(
                'nav',
                { className: 'footer-main site-footer__nav', 'aria-label': 'Links do rodap\xE9' },
                footerRows.map(function (row, rowIndex) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'site-footer__nav-row', key: rowIndex },
                        row.map(function (section) {
                            return _react2.default.createElement(
                                'section',
                                { className: 'footer-section site-footer__section', key: section.title },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'section-title site-footer__col-title' },
                                    section.title
                                ),
                                section.content || _react2.default.createElement(
                                    'div',
                                    { className: 'section-links site-footer__links' },
                                    section.links.map(function (link, linkIndex) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'link-item', key: link.url || linkIndex },
                                            renderLink(link, 'footer-link site-footer__link')
                                        );
                                    })
                                )
                            );
                        })
                    );
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'footer-bottom site-footer__bar' },
            _react2.default.createElement(
                'div',
                { className: 'footer-container site-footer__bar-inner' },
                _react2.default.createElement(
                    'div',
                    { className: 'logo-container' },
                    _react2.default.createElement(
                        'a',
                        { href: '/', className: 'mercos-logo site-footer__bar-logo-link' },
                        _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/mercos-nuvini.svg', alt: 'Mercos - uma empresa nuvini' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'company-info site-footer__legal' },
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA9 ',
                        new Date().getFullYear(),
                        ' Simplest Software Ltda. Todos os direitos reservados.'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        'CNPJ: 12.496.510/0001-80 \xB7 Av. Rolf Wiest, 277 (4\xBA andar) \xB7 Bom Retiro \u2014 Joinville/SC \xB7 CEP: 89223-005'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'social-links site-footer__social' },
                    socialLinks.map(function (social) {
                        return _react2.default.createElement(
                            'a',
                            {
                                key: social.name,
                                href: social.url,
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                className: 'social-link site-footer__social-link',
                                'aria-label': social.name
                            },
                            _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: social.icon, alt: 'Mercos no ' + social.name })
                        );
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'feito-com-amor site-footer__made' },
                        'Feito com \uD83D\uDC9C'
                    )
                )
            )
        )
    );
}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

__webpack_require__(548);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _siteNavData = __webpack_require__(549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderItemTitle = function renderItemTitle(title) {
  if (typeof title === 'string') {
    return _react2.default.createElement(
      'h4',
      null,
      title
    );
  }
  return _react2.default.createElement(
    'h4',
    null,
    title
  );
};

var SiteNav = function SiteNav(_ref) {
  var _ref$hideOnScroll = _ref.hideOnScroll,
      hideOnScroll = _ref$hideOnScroll === undefined ? false : _ref$hideOnScroll,
      _ref$menuVisible = _ref.menuVisible,
      menuVisible = _ref$menuVisible === undefined ? true : _ref$menuVisible,
      _ref$pixelsToShowMenu = _ref.pixelsToShowMenuWhite,
      pixelsToShowMenuWhite = _ref$pixelsToShowMenu === undefined ? 50 : _ref$pixelsToShowMenu,
      _ref$transparentOnTop = _ref.transparentOnTop,
      transparentOnTop = _ref$transparentOnTop === undefined ? false : _ref$transparentOnTop,
      _ref$whiteBackground = _ref.whiteBackground,
      whiteBackground = _ref$whiteBackground === undefined ? false : _ref$whiteBackground,
      _ref$promoBarHeight = _ref.promoBarHeight,
      promoBarHeight = _ref$promoBarHeight === undefined ? 0 : _ref$promoBarHeight,
      _ref$loginOnly = _ref.loginOnly,
      loginOnly = _ref$loginOnly === undefined ? false : _ref$loginOnly,
      _ref$logoOnly = _ref.logoOnly,
      logoOnly = _ref$logoOnly === undefined ? false : _ref$logoOnly;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeMenu = _useState2[0],
      setActiveMenu = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isAtTop = _useState4[0],
      setIsAtTop = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mobileMenuOpen = _useState6[0],
      setMobileMenuOpen = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      mobileOpenSections = _useState8[0],
      setMobileOpenSections = _useState8[1];

  var closeTimerRef = (0, _react.useRef)(null);
  var dropdownRefs = (0, _react.useRef)([]);

  var showTransparentTop = transparentOnTop && isAtTop && !whiteBackground && !mobileMenuOpen;

  var closeMobileMenu = (0, _react.useCallback)(function () {
    setMobileMenuOpen(false);
    setMobileOpenSections({});
  }, []);

  var toggleMobileMenu = function toggleMobileMenu() {
    if (mobileMenuOpen) {
      closeMobileMenu();
    } else {
      setMobileMenuOpen(true);
    }
  };

  var toggleMobileSection = function toggleMobileSection(index) {
    setMobileOpenSections(function (prev) {
      return _extends({}, prev, _defineProperty({}, index, !prev[index]));
    });
  };

  var closeAllDropdowns = function closeAllDropdowns() {
    return setActiveMenu(null);
  };

  var handleNavItemEnter = function handleNavItemEnter(index) {
    clearTimeout(closeTimerRef.current);
    setActiveMenu(index);

    var dd = dropdownRefs.current[index];
    if (!dd) return;

    dd.style.left = '';
    dd.style.right = '';

    requestAnimationFrame(function () {
      var rect = dd.getBoundingClientRect();
      var vw = window.innerWidth;
      if (rect.right > vw - 8) {
        var overflow = rect.right - (vw - 8);
        var currentLeft = parseFloat(window.getComputedStyle(dd).left) || 0;
        if (dd.style.right === '') {
          dd.style.left = currentLeft - overflow + 'px';
        }
      }
      if (rect.left < 8) {
        dd.style.left = '0px';
      }
    });
  };

  var handleNavItemLeave = function handleNavItemLeave(index) {
    closeTimerRef.current = setTimeout(function () {
      setActiveMenu(function (current) {
        return current === index ? null : current;
      });
    }, 100);
  };

  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsAtTop(scrollTop <= pixelsToShowMenuWhite);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pixelsToShowMenuWhite]);

  (0, _react.useEffect)(function () {
    document.body.classList.toggle('mobile-menu-is-open', mobileMenuOpen);
    if (!mobileMenuOpen) {
      return undefined;
    }

    var onKeyDown = function onKeyDown(event) {
      if (event.key === 'Escape') {
        closeMobileMenu();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return function () {
      document.body.classList.remove('mobile-menu-is-open');
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [mobileMenuOpen, closeMobileMenu]);

  (0, _react.useEffect)(function () {
    var onDocumentClick = function onDocumentClick(event) {
      if (!event.target.closest('.site-nav__item')) {
        closeAllDropdowns();
      }
    };

    var onEscape = function onEscape(event) {
      if (event.key === 'Escape') {
        closeAllDropdowns();
      }
    };

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onEscape);

    return function () {
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onEscape);
      clearTimeout(closeTimerRef.current);
    };
  }, []);

  var navClassName = ['site-nav', hideOnScroll ? 'hide-on-scroll' : '', hideOnScroll && !menuVisible ? 'menu-hidden' : 'menu-visible', showTransparentTop ? 'at-top' : 'scrolled', promoBarHeight > 0 ? 'has-promo-bar' : '', mobileMenuOpen ? 'mobile-open' : '', logoOnly ? 'logo-only' : ''].filter(Boolean).join(' ');

  var menuItems = loginOnly ? [] : _siteNavData.siteNavData;

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' })
    ),
    _react2.default.createElement(
      'header',
      { className: navClassName, id: 'siteHeader' },
      _react2.default.createElement(
        'a',
        { href: '/', className: 'site-nav__logo', 'aria-label': 'Mercos' },
        _react2.default.createElement(_Picture2.default, {
          src: '/images/site/logo-mercos-colored.svg',
          alt: 'Mercos',
          className: 'site-nav__logo-img'
        })
      ),
      !loginOnly && !logoOnly && _react2.default.createElement(
        'nav',
        { className: 'site-nav__desktop', 'aria-label': 'Navega\xE7\xE3o principal' },
        _react2.default.createElement(
          'ul',
          { className: 'site-nav__menu' },
          menuItems.map(function (menuItem, idx) {
            return _react2.default.createElement(
              'li',
              {
                key: menuItem.label,
                className: 'site-nav__item' + (activeMenu === idx ? ' open' : ''),
                onMouseEnter: function onMouseEnter() {
                  return handleNavItemEnter(idx);
                },
                onMouseLeave: function onMouseLeave() {
                  return handleNavItemLeave(idx);
                }
              },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'site-nav__trigger',
                  'aria-haspopup': 'true',
                  'aria-expanded': activeMenu === idx
                },
                menuItem.label
              ),
              _react2.default.createElement(
                'div',
                {
                  ref: function ref(el) {
                    dropdownRefs.current[idx] = el;
                  },
                  className: 'site-nav__dropdown' + (menuItem.grid ? ' site-nav__dropdown--grid' : ''),
                  role: 'menu'
                },
                menuItem.items.map(function (item, subIdx) {
                  if (item.type === 'separator') {
                    return _react2.default.createElement(
                      'div',
                      { key: item.label + '-' + subIdx, className: 'site-nav__dd-label' },
                      item.label
                    );
                  }

                  return _react2.default.createElement(
                    'a',
                    {
                      key: item.link + '-' + subIdx,
                      href: item.link,
                      className: 'site-nav__dd-item',
                      role: 'menuitem',
                      target: item.target,
                      rel: item.target === '_blank' ? 'noopener noreferrer' : undefined
                    },
                    _react2.default.createElement(
                      'span',
                      { className: 'material-icons site-nav__dd-icon' },
                      item.icon
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'site-nav__dd-text' },
                      renderItemTitle(item.title),
                      item.description ? _react2.default.createElement(
                        'p',
                        null,
                        item.description
                      ) : null
                    )
                  );
                })
              )
            );
          })
        )
      ),
      !logoOnly && _react2.default.createElement(
        'div',
        { className: 'site-nav__actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__mobile-cta',
          onClick: function onClick() {
            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
          }
        },
        'comece gr\xE1tis'
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__hamburger' + (mobileMenuOpen ? ' active' : ''),
          id: 'headerHamburger',
          'aria-label': mobileMenuOpen ? 'Fechar menu' : 'Abrir menu',
          'aria-expanded': mobileMenuOpen,
          'aria-controls': 'mobileNav',
          onClick: toggleMobileMenu
        },
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null)
      )
    ),
    !logoOnly && _react2.default.createElement(
      'nav',
      {
        className: 'site-nav__mobile' + (mobileMenuOpen ? ' active' : ''),
        id: 'mobileNav',
        'aria-label': 'Menu mobile',
        'aria-hidden': !mobileMenuOpen
      },
      menuItems.map(function (menuItem, idx) {
        return _react2.default.createElement(
          'div',
          {
            key: menuItem.label,
            className: 'site-nav__mob-section' + (mobileOpenSections[idx] ? ' open' : '')
          },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'site-nav__mob-toggle',
              onClick: function onClick() {
                return toggleMobileSection(idx);
              }
            },
            menuItem.label,
            _react2.default.createElement(
              'span',
              { className: 'material-icons' },
              'expand_more'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'site-nav__mob-items' },
            _react2.default.createElement(
              'div',
              { className: 'site-nav__mob-items-inner' },
              menuItem.items.map(function (item, subIdx) {
                if (item.type === 'separator') {
                  return _react2.default.createElement(
                    'div',
                    { key: item.label + '-' + subIdx, className: 'site-nav__mob-label' },
                    item.label
                  );
                }

                return _react2.default.createElement(
                  'a',
                  {
                    key: item.link + '-' + subIdx,
                    href: item.link,
                    className: 'site-nav__mob-item',
                    target: item.target,
                    rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
                    onClick: closeMobileMenu
                  },
                  _react2.default.createElement(
                    'span',
                    { className: 'material-icons' },
                    item.icon
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    renderItemTitle(item.title),
                    item.description ? _react2.default.createElement(
                      'p',
                      null,
                      item.description
                    ) : null
                  )
                );
              })
            )
          )
        );
      }),
      _react2.default.createElement(
        'div',
        { className: 'site-nav__mob-actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      )
    )
  );
};

exports.default = SiteNav;

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteNavData = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteNavData = exports.siteNavData = [{
  label: 'Soluções',
  items: [{
    title: 'Força de vendas',
    description: '+25 indicadores e +30 relatórios para gerenciar sua equipe',
    icon: 'bar_chart',
    link: '/forca-vendas/'
  }, {
    title: 'E-commerce B2B',
    description: 'Venda 24h por dia com a loja online de empresas para empresas',
    icon: 'shopping_cart',
    link: '/e-commerce-b2b'
  }, {
    type: 'separator',
    label: 'Outras Soluções'
  }, {
    title: 'CRM',
    description: 'Cuide da prospecção ao pós-venda dos clientes em um só lugar',
    icon: 'filter_alt',
    link: '/crm-de-vendas'
  }, {
    title: 'Mercos Pay',
    description: 'Receba pagamentos por pix, boleto e cartões de crédito',
    icon: 'credit_card',
    link: '/mercos-pay'
  }, {
    title: 'Videochamada',
    description: 'Venda por vídeo com experiência de visita presencial',
    icon: 'videocam',
    link: '/videochamada'
  }]
}, {
  label: 'Segmentos',
  items: [{
    title: 'Indústrias',
    description: 'Automatize vendas, conecte canais e escale seu negócio com inteligência',
    icon: 'factory',
    link: '/sistema-para-industria/'
  }, {
    title: 'Distribuidoras',
    description: 'Gerencie clientes e pedidos, vendas automatizadas e integração total',
    icon: 'home_work',
    link: '/sistema-distribuidora/'
  }, {
    title: 'Representantes',
    description: 'Crie e gerencie políticas comerciais para cada cliente e representada',
    icon: 'work',
    link: '/sistema-representante/'
  }]
}, {
  label: 'Planos e preços',
  items: [{
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Ind\xFAstrias e distribuidoras'
      )
    ),
    description: '',
    icon: 'factory',
    link: '/planos-e-precos/industrias-e-distribuidoras/'
  }, {
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Representantes'
      )
    ),
    description: '',
    icon: 'work',
    link: '/planos-e-precos/representantes/'
  }]
}, {
  label: 'Integrações',
  items: [{
    title: 'ERPs integrados',
    description: '+250 ERPs parceiros integrados ao Força de vendas e E-commerce B2B',
    icon: 'device_hub',
    link: '/integracao-erp'
  }, {
    title: 'Seja Parceiro',
    description: 'Seja um Mpartner e leve seu negócio ao próximo nível',
    icon: 'people',
    link: '/parceiros'
  }]
}, {
  label: 'Recursos',
  grid: true,
  items: [{
    title: 'Aplicativo de vendas',
    description: 'Emita pedidos até sem internet e agilize a rotina do seu time comercial.',
    icon: 'smartphone',
    link: '/recursos/aplicativo-vendas-externas/'
  }, {
    title: 'Mercos IA',
    description: 'Inteligência Artificial na palma da sua mão',
    icon: 'auto_awesome',
    link: '/recursos/mercos-ia/'
  }, {
    title: 'Indicadores de vendas',
    description: 'Visualize a performance do seu comercial em tempo real e tome decisões mais rápidas.',
    icon: 'show_chart',
    link: '/recursos/indicadores-performance/'
  }, {
    title: 'Materiais ricos',
    description: 'Ebooks e guias para turbinar sua estratégia de vendas B2B.',
    icon: 'menu_book',
    link: '/materiais/'
  }, {
    title: 'Políticas comerciais',
    description: 'Aplique regras de preço, desconto e acréscimo sem erro – tudo de forma automática.',
    icon: 'flag',
    link: '/recursos/politica-comercial-vendas/'
  }, {
    title: 'Cases',
    description: 'Veja cases de sucesso e inspire melhores resultados para sua empresa.',
    icon: 'rocket_launch',
    link: 'https://mercos.com/cases/'
  }]
}];

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SiteNav = __webpack_require__(547);

var _SiteNav2 = _interopRequireDefault(_SiteNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SiteNav2.default;

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonLink = function ButtonLink(_ref) {
    var children = _ref.children,
        color = _ref.color,
        model = _ref.model,
        size = _ref.size,
        radius = _ref.radius,
        className = _ref.className,
        _ref$href = _ref.href,
        href = _ref$href === undefined ? '/' : _ref$href,
        target = _ref.target,
        rel = _ref.rel,
        title = _ref.title,
        onClick = _ref.onClick,
        style = _ref.style,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        shake = _ref.shake;
    return _react2.default.createElement(
        'a',
        { className: (0, _classnames2.default)('button', model, size, radius, className, color, shake && 'shake'),
            href: href,
            target: target,
            title: title,
            onClick: onClick,
            style: style,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            rel: rel ? rel : target === '_blank' ? 'noopener noreferrer' : '' },
        children
    );
};

ButtonLink.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.any,
    color: _propTypes2.default.string,
    href: _propTypes2.default.string,
    model: _propTypes2.default.oneOf(['outline', 'secondary', 'success', 'alert', 'warning']),
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded']),
    size: _propTypes2.default.string,
    target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
    title: _propTypes2.default.string
};

exports.default = ButtonLink;

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading5 = function Heading5(_ref) {
    var children = _ref.children,
        white = _ref.white,
        left = _ref.left,
        className = _ref.className,
        green = _ref.green,
        gray = _ref.gray,
        center = _ref.center,
        onClick = _ref.onClick;
    return _react2.default.createElement(
        'h5',
        { className: (0, _classnames2.default)(className, 'heading5', left && 'text-left', white ? 'heading-white' : '', green ? 'heading-green' : '', gray ? 'heading-5-gray' : '', center ? 'text-center' : ''), onClick: onClick },
        children
    );
};

exports.default = Heading5;

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading1 = function Heading1(_ref) {
    var children = _ref.children,
        white = _ref.white,
        center = _ref.center,
        className = _ref.className,
        left = _ref.left,
        style = _ref.style,
        purple = _ref.purple,
        black = _ref.black;
    return _react2.default.createElement(
        'h1',
        { style: style,
            className: (0, _classnames2.default)('heading1', className, white && 'heading-white', center && 'text-center', left && 'text-left', purple && 'heading-purple', black && 'heading-black') },
        children
    );
};

exports.default = Heading1;

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _emailjsCom = __webpack_require__(893);

var emailjs = _interopRequireWildcard(_emailjsCom);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _ButtonLink = __webpack_require__(557);

var _ButtonLink2 = _interopRequireDefault(_ButtonLink);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

__webpack_require__(672);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'phone', 'erp', 'needs'];

var RequestContactv2 = function (_Component) {
    _inherits(RequestContactv2, _Component);

    function RequestContactv2(props) {
        _classCallCheck(this, RequestContactv2);

        var _this = _possibleConstructorReturn(this, (RequestContactv2.__proto__ || Object.getPrototypeOf(RequestContactv2)).call(this, props));

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);
        return _this;
    }

    _createClass(RequestContactv2, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                showDemoForm: false,
                name: '',
                email: '',
                phone: '',
                erp: '',
                needs: '',
                typingTimeout: 0
            };

            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });

            return initialObject;
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true,
                showDemoForm: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false,
                showDemoForm: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var stateKey = void 0;
            var targetId = e.target.id;
            var value = e.target.value;

            if (targetId.includes('-field')) {
                stateKey = targetId.substring(0, targetId.indexOf('-field'));
            } else if (targetId === 'email') {
                stateKey = 'email';
            } else if (targetId === 'telephone') {
                stateKey = 'phone';
            } else {
                stateKey = targetId;
            }

            if (stateKey === 'phone') {
                value = this.phoneMask(value);
            }

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, stateKey, value), _defineProperty(_setState, stateKey + 'Error', false), _defineProperty(_setState, stateKey + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (stateKey === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};

            var regexPhone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            FIELDS.forEach(function (campo) {
                newState[campo + 'Error'] = !_this3.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'phone':
                        {
                            newState[campo + 'Error'] = !regexPhone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(email.toLowerCase());
        }
    }, {
        key: 'phoneMask',
        value: function phoneMask(value) {
            var cleanPhone = value ? value.replace(/\D/g, "") : '',
                numberLength = cleanPhone.length;

            if (numberLength > 10) {
                cleanPhone = cleanPhone.slice(0, 7) + '-' + cleanPhone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanPhone = cleanPhone.slice(0, 6) + '-' + cleanPhone.slice(6);
            }

            if (numberLength > 2) {
                cleanPhone = cleanPhone.slice(0, 2) + ') ' + cleanPhone.slice(2);
            }

            if (numberLength > 0) {
                cleanPhone = '(' + cleanPhone.slice(0);
            }

            return cleanPhone;
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            var _this4 = this;

            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicitou-contato-parceiro-marketplace',
                    'cf_tipo_de_conversao': 'Solicitou contato de um parceiro no Marketplace',
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.phone,
                    cf_erp_utilizado: this.state.erp,
                    cf_descricao_da_necessidade: this.state.needs || '',
                    cf_carteira_clientes_canais: this.props.portifolioOwner || '',
                    'cf_codigo_do_parceiro_meus_pedidos': this.props.partnerId,
                    'cf_nome_do_parceiro_canais1': this.props.partnerName

                };

                emailjs.send('amazon_ses', 'template_marketplace', {
                    partnerEmail: this.props.partnerEmail,
                    contactName: this.state.name,
                    contactEmail: this.state.email,
                    contactPhone: this.state.phone,
                    contactErp: this.state.erp,
                    contactNeeds: this.state.needs || ''
                }, 'user_FFC9ya35Vf3Im0waOm5He');

                this.rdGateway.sendToRDStation(data);

                this.setState({
                    showDemoForm: false
                });

                setTimeout(function () {
                    _this4.setState({
                        showDemoModal: false,
                        showDemoForm: true
                    });
                }, 3000);
            }
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this5 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this5.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('new-form-wrapper', this.state.showDemoForm ? '' : 'hide') },
                    _react2.default.createElement(
                        'h4',
                        { className: 'form-heading' },
                        'Preencha o formul\xE1rio abaixo e solicite um contato agora mesmo'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this5.submitForm(e);
                            } },
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name-field', value: this.state.name, onChange: function onChange(e) {
                                return _this5.handleChange(e);
                            }, error: this.state.nameError, autoFocus: true, placeholder: 'Nome' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this5.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.phone, onChange: function onChange(e) {
                                return _this5.handleChange(e);
                            }, error: this.state.phoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'erp-field', value: this.state.erp, onChange: function onChange(e) {
                                return _this5.handleChange(e);
                            }, error: this.state.erpError, placeholder: 'Qual ERP usa atualmente?' }),
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'needs-field' },
                            'Descreva sua necessidade:'
                        ),
                        _react2.default.createElement('textarea', { id: 'needs-field', defaultValue: this.state.needs, onChange: function onChange(e) {
                                return _this5.handleChange(e);
                            } }),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', radius: this.props.radius, className: this.props.className },
                                'SOLICITAR CONTATO'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('container-form-confirm', !this.state.showDemoForm ? '' : 'hide') },
                    _react2.default.createElement(_Picture2.default, { className: 'success-icon', src: '/images/success.png', alt: 'Solicita\xE7\xE3o enviada com sucesso!' }),
                    _react2.default.createElement(
                        'p',
                        { className: 'paragraph' },
                        'Sua solicita\xE7\xE3o foi enviada com sucesso!'
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    _ButtonLink2.default,
                    _extends({
                        href: '.',
                        className: (0, _classnames2.default)(this.props.className, this.props.color === '#FFFFFF' ? '#494a5e' : this.props.color && 'colored'),
                        onClick: function onClick(e) {
                            return _this6.openDemoModal(e);
                        },
                        title: 'Solicite o contato de um dos nossos especialistas.',
                        radius: this.props.radius,
                        size: this.props.size,
                        style: this.props.style
                    }, this.props.color && { style: { color: this.props.color } }),
                    this.props.children || 'peça uma demonstração'
                ),
                this.state.showDemoModal && this.getDemoModal()
            );
        }
    }]);

    return RequestContactv2;
}(_react.Component);

RequestContactv2.propTypes = {
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    radius: _propTypes2.default.string
};
RequestContactv2.defaultProps = {
    radius: 'half-rounded'
};
exports.default = RequestContactv2;

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailJSResponseStatus = exports.sendForm = exports.send = exports.init = void 0;
var EmailJSResponseStatus_1 = __webpack_require__(894);
Object.defineProperty(exports, "EmailJSResponseStatus", { enumerable: true, get: function () { return EmailJSResponseStatus_1.EmailJSResponseStatus; } });
var UI_1 = __webpack_require__(895);
var _userID = null;
var _origin = 'https://api.emailjs.com';
function sendPost(url, data, headers) {
    if (headers === void 0) { headers = {}; }
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.addEventListener('load', function (event) {
            var responseStatus = new EmailJSResponseStatus_1.EmailJSResponseStatus(event.target);
            if (responseStatus.status === 200 || responseStatus.text === 'OK') {
                resolve(responseStatus);
            }
            else {
                reject(responseStatus);
            }
        });
        xhr.addEventListener('error', function (event) {
            reject(new EmailJSResponseStatus_1.EmailJSResponseStatus(event.target));
        });
        xhr.open('POST', url, true);
        for (var key in headers) {
            xhr.setRequestHeader(key, headers[key]);
        }
        xhr.send(data);
    });
}
function appendGoogleCaptcha(templatePrams) {
    var element = document && document.getElementById('g-recaptcha-response');
    if (element && element.value) {
        templatePrams['g-recaptcha-response'] = element.value;
    }
    element = null;
    return templatePrams;
}
function fixIdSelector(selector) {
    if (selector[0] !== '#' && selector[0] !== '.') {
        return '#' + selector;
    }
    return selector;
}
/**
 * Initiation
 * @param {string} userID - set the EmailJS user ID
 * @param {string} origin - set the EmailJS origin
 */
function init(userID, origin) {
    _userID = userID;
    _origin = origin || 'https://api.emailjs.com';
}
exports.init = init;
/**
 * Send a template to the specific EmailJS service
 * @param {string} serviceID - the EmailJS service ID
 * @param {string} templateID - the EmailJS template ID
 * @param {Object} templatePrams - the template params, what will be set to the EmailJS template
 * @param {string} userID - the EmailJS user ID
 * @returns {Promise<EmailJSResponseStatus>}
 */
function send(serviceID, templateID, templatePrams, userID) {
    var params = {
        lib_version: '2.6.4',
        user_id: userID || _userID,
        service_id: serviceID,
        template_id: templateID,
        template_params: appendGoogleCaptcha(templatePrams)
    };
    return sendPost(_origin + '/api/v1.0/email/send', JSON.stringify(params), {
        'Content-type': 'application/json'
    });
}
exports.send = send;
/**
 * Send a form the specific EmailJS service
 * @param {string} serviceID - the EmailJS service ID
 * @param {string} templateID - the EmailJS template ID
 * @param {string | HTMLFormElement} form - the form element or selector
 * @param {string} userID - the EmailJS user ID
 * @returns {Promise<EmailJSResponseStatus>}
 */
function sendForm(serviceID, templateID, form, userID) {
    if (typeof form === 'string') {
        form = document.querySelector(fixIdSelector(form));
    }
    if (!form || form.nodeName !== 'FORM') {
        throw 'Expected the HTML form element or the style selector of form';
    }
    UI_1.UI.progressState(form);
    var formData = new FormData(form);
    formData.append('lib_version', '2.6.4');
    formData.append('service_id', serviceID);
    formData.append('template_id', templateID);
    formData.append('user_id', userID || _userID);
    return sendPost(_origin + '/api/v1.0/email/send-form', formData)
        .then(function (response) {
        UI_1.UI.successState(form);
        return response;
    }, function (error) {
        UI_1.UI.errorState(form);
        return Promise.reject(error);
    });
}
exports.sendForm = sendForm;
exports.default = {
    init: init,
    send: send,
    sendForm: sendForm
};


/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailJSResponseStatus = void 0;
var EmailJSResponseStatus = /** @class */ (function () {
    function EmailJSResponseStatus(httpResponse) {
        this.status = httpResponse.status;
        this.text = httpResponse.responseText;
    }
    return EmailJSResponseStatus;
}());
exports.EmailJSResponseStatus = EmailJSResponseStatus;


/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.UI = void 0;
var UI = /** @class */ (function () {
    function UI() {
    }
    UI.clearAll = function (form) {
        form.classList.remove(this.PROGRESS);
        form.classList.remove(this.DONE);
        form.classList.remove(this.ERROR);
    };
    UI.progressState = function (form) {
        this.clearAll(form);
        form.classList.add(this.PROGRESS);
    };
    UI.successState = function (form) {
        form.classList.remove(this.PROGRESS);
        form.classList.add(this.DONE);
    };
    UI.errorState = function (form) {
        form.classList.remove(this.PROGRESS);
        form.classList.add(this.ERROR);
    };
    UI.PROGRESS = 'emailjs-sending';
    UI.DONE = 'emailjs-success';
    UI.ERROR = 'emailjs-error';
    return UI;
}());
exports.UI = UI;


/***/ }),

/***/ 896:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/marketplace/MarketplacePartnerv2.jsx.d64268ed.js